import React from 'react'
import moment from 'moment'
import { Icon } from 'semantic-ui-react'


export const uploaderTypeOptions = [
    { key: 'Segmap', text: 'Segmap', value: 'Segmap' },
    // { key: 'Ledgermap', text: 'Ledgermap', value: 'Ledgermap' },
    // { key: 'Itemmap', text: 'Itemmap', value: 'Itemmap' },
    // { key: 'Vtparammap', text: 'Vtparammap', value: 'Vtparammap' },
    // { key: 'Vtype', text: 'Vtype', value: 'Vtype' },
]


export const uploaderListSearch = () => {
    const today = moment().format('YYYY-MM-DD')
    return {
        from_date: today,
        to_date: today,
        type: 'Segmap',
    }
}


// Server stores files as "<uuid>#@#<real_filename>.zip"; display the real filename without the .zip wrap.
export const cleanUploaderFileName = (raw) => {
    if (!raw) return ''
    const parts = String(raw).split('#@#')
    const tail = parts.length > 1 ? parts[parts.length - 1] : parts[0]
    return tail.replace(/\.zip$/i, '')
}


const cellText = (val, width) => {
    const v = (val === undefined || val === null || val === 'NULL') ? '' : String(val)
    return (
        <div className='ellipsisDiv' style={{ width: width || '100%', paddingLeft: '5px' }} title={v}>
            {v}
        </div>
    )
}


const fileNameCell = (row, onDownloadOriginal, downloadingId) => {
    const val = row.value
    const raw = (val === undefined || val === null || val === 'NULL') ? '' : String(val)
    if (!raw) {
        return <div style={{ paddingLeft: '5px', color: '#bbb' }}>—</div>
    }
    const displayName = cleanUploaderFileName(raw)
    const original = (row.row && row.row.original) || {}
    const id = original.id
    const isBusy = downloadingId === id + ':original'
    return (
        <div
            className='ellipsisDiv'
            style={{
                paddingLeft: '5px',
                color: '#2185d0',
                cursor: isBusy ? 'wait' : 'pointer',
                textDecoration: 'underline',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
            }}
            title={isBusy ? 'Downloading...' : `Click to download ${displayName}`}
            onClick={(e) => {
                e.stopPropagation()
                if (!isBusy && onDownloadOriginal && id) onDownloadOriginal(id, displayName)
            }}
        >
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {displayName}
            </span>
            {isBusy && <Icon name='spinner' loading style={{ margin: 0 }} />}
        </div>
    )
}


const statusCell = (val) => {
    const v = (val === undefined || val === null) ? '' : String(val)
    const lower = v.toLowerCase()
    let color = '#5a7a99'
    if (lower === 'success' || lower === 'done' || lower === 'completed') color = '#21ba45'
    else if (lower === 'error' || lower === 'failed') color = '#db2828'
    else if (lower === 'pending' || lower === 'in-process' || lower === 'in_process' || lower === 'processing') color = '#f2711c'
    return (
        <div style={{ paddingLeft: '5px', color, fontWeight: 600, textTransform: 'capitalize' }} title={v}>
            {v}
        </div>
    )
}


const errorFileCell = (row, onDownloadError, downloadingId) => {
    const val = row.value
    const raw = (val === undefined || val === null || val === 'NULL') ? '' : String(val)
    if (!raw) {
        return <div style={{ paddingLeft: '5px', color: '#bbb' }}>—</div>
    }
    const displayName = cleanUploaderFileName(raw)
    const original = (row.row && row.row.original) || {}
    const id = original.id
    const isBusy = downloadingId === id + ':Error'
    return (
        <div
            className='ellipsisDiv'
            style={{
                paddingLeft: '5px',
                color: '#2185d0',
                cursor: isBusy ? 'wait' : 'pointer',
                textDecoration: 'underline',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
            }}
            title={isBusy ? 'Downloading...' : `Click to download ${displayName}`}
            onClick={(e) => {
                e.stopPropagation()
                if (!isBusy && onDownloadError && id) onDownloadError(id, displayName)
            }}
        >
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {displayName}
            </span>
            {isBusy && <Icon name='spinner' loading style={{ margin: 0 }} />}
        </div>
    )
}


export const getSearchColumns = ({ onDownloadOriginal, onDownloadError, downloadingId } = {}) => [
    {
        Header: <div style={{ textAlign: 'left' }}>File Name</div>,
        accessor: 'org_name',
        Cell: row => fileNameCell(row, onDownloadOriginal, downloadingId),
        classNameGet: 'uploaderfilter1',
    },
    {
        Header: <div style={{ textAlign: 'left' }}>Type</div>,
        accessor: 'import_type',
        Cell: row => cellText(row.value),
        classNameGet: 'uploaderfilter2',
    },
    {
        Header: <div style={{ textAlign: 'left' }}>Account</div>,
        accessor: 'dms_account',
        Cell: row => cellText(row.value),
        classNameGet: 'uploaderfilter3',
    },
    {
        Header: <div style={{ textAlign: 'left' }}>Status</div>,
        accessor: 's3_status',
        Cell: row => statusCell(row.value),
        classNameGet: 'uploaderfilter4',
    },
    {
        Header: <div style={{ textAlign: 'left' }}>Error File</div>,
        accessor: 'error_file_name',
        Cell: row => errorFileCell(row, onDownloadError, downloadingId),
        classNameGet: 'uploaderfilter5',
    },
    {
        Header: <div style={{ textAlign: 'left' }}>Created On</div>,
        accessor: 'dt_create',
        Cell: row => cellText(row.value),
        classNameGet: 'uploaderfilter6',
    },
    {
        Header: <div style={{ textAlign: 'left' }}>Updated On</div>,
        accessor: 'dt_update',
        Cell: row => cellText(row.value),
        classNameGet: 'uploaderfilter7',
    },
]


export const searchColumns = getSearchColumns()
